import React, { Component } from 'react';
import { dbQuery } from "../../../../api"
import { User, Users } from 'react-feather';
import Switch from "react-switch";

import '../../../../index.scss';

class EventAvailabilityCube extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true,
            data: 0
        }
    }

    doQuery = () => {
        if (this.props.query) {       
            dbQuery(this.props.query).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});                    
    };

    doLocalQuery = () => {

        return 0;        
    }

    componentDidMount() {
        this.doQuery();
    }

    render(){
        if (this.state.loading) { return null; }
        const {tournament, round, event, tUser} = this.props;
        var tUserRound = tUser.rounds.find(x=>x.roundId === round._id);        
        var tUserRoundEvent = tUserRound ? tUserRound.events.find(x=>x.eventId === event.eventId) : null;        
        var isAvailable = tUserRoundEvent ? tUserRoundEvent.isAvailable : false;      
        
        const tEvent = tournament.events.find(x=>x._id === event.eventId);

        var bg = 'bg-';
        var font = 'font-';
        if (tEvent) {
            if (tEvent.category === 'debate') { bg += 'warning'; font += 'warning' }
            if (tEvent.category === 'limited-prep') { bg += 'danger'; font += 'danger' }
            if (tEvent.category === 'platform') { bg += 'primary'; font += 'primary' }
            if (tEvent.category === 'interp') { bg += 'info'; font += 'info' }
        }

        return (
            <div className="card o-hidden widget-cards">
                <div className={`${bg} card-body`}>
                    <div className="media static-top-widget row">
                        <div className="icons-widgets col-3">
                            
                        <div className="align-self-center text-center">{tEvent.teamSize === 1 ? <User className={font} /> : <Users className={font} />}</div>
                            <br/>
                            <Switch 
                                onChange={this.props.onStatusIconClick}
                                checked={isAvailable}
                                className="react-switch"
                            />
                        </div>

                        <div className="media-body col-9">
                            <span className="m-0" >
                                <h3>{event.title}&nbsp;</h3>
                            </span>
{/*}
                            <h3 className="mb-0">
                                <CountUp className="counter" end={this.doLocalQuery(round, event,user)} />
                                <small>   
                                    &nbsp;Remaining Judges Needed
                                </small>
                            </h3>
*/}
                            <h3 className="mb-0">
                                {isAvailable 
                                ?  <><small>My Status: Available</small></>
                                :  <><small>My Status: Not Available</small></>
                                }                                
                            </h3>                            
                        </div>    
                    </div>
                </div>
            </div>    
        )
    }
}

export default EventAvailabilityCube;